class orderService {

    constructor($http) {
        'ngInject';

        this.$http = $http;
        this.apiMainUrl = '/admpanel/configurator/';
    }

    getOrderModels(orderId) {
        return this.$http.get(
            `/admpanel/ajax/configurator/getOrderModels/${orderId}`
        );
    }
}

export default orderService;